import React from 'react';
import Container from '../components/Container';
import Button from '../components/Button';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <Container className="py-24 text-center">
      <h1 className="text-4xl font-extrabold text-slate-900">404</h1>
      <p className="mt-2 text-slate-600">La page demandée est introuvable.</p>
      <Button as={Link} to="/" className="mt-6">Retour à l’accueil</Button>
    </Container>
  );
}


